import React, { useState, useEffect } from "react";
import '../css/detail.css';
import sliceIntoChunks from "../untils";
import { supabase } from '../supabaseClient';
import { v4 } from 'uuid';

const PER_PAGE = 24;

function Detail() {
    const [page, setPage]             = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [dataList, setDataList]     = useState([]);
    const [colCount, setColCount]     = useState(() => window.innerWidth >= 768 && window.innerWidth <= 990 ? 3 : 4);
    const [select, setSelect]         = useState(null);
    const [showModal, setShowModal]   = useState(false);
    const [loading, setLoading]       = useState(true);

    /* ── fetch images cho 1 folder ── */
    const fetchImages = async (patch) => {
        const { data, error } = await supabase.storage
            .from('images_prod')
            .list(patch, { limit: 3 });
        if (error || !data) return;

        const urls = data
            .map(img => supabase.storage.from('images_prod').getPublicUrl(`${patch}/${img.name}`).data.publicUrl)
            .filter(url => !url.includes('.emptyFolderPlaceholder'));

        setDataList(prev => prev.map(item =>
            item.patch === patch ? { ...item, img1: urls[0] || '', img2: urls[1] || '' } : item
        ));
    };

    /* ── fetch tên tùy chỉnh từ DB ── */
    const fetchNames = async () => {
        try {
            const { data } = await supabase.from('product_names').select('*');
            if (data?.length) {
                const map = Object.fromEntries(data.map(r => [r.patch, r.name]));
                setDataList(prev => prev.map(item =>
                    map[item.patch] ? { ...item, name: map[item.patch] } : item
                ));
            }
        } catch (_) {}
    };

    /* ── khám phá folders có ảnh từ bucket ── */
    const load = async (currentPage) => {
        const { data: rootItems } = await supabase.storage
            .from('images_prod')
            .list('', { limit: 500 });

        const folders = (rootItems || [])
            .filter(item => /^img\d+$/.test(item.name))
            .sort((a, b) => Number(b.name.slice(3)) - Number(a.name.slice(3)));

        setTotalPages(Math.max(1, Math.ceil(folders.length / PER_PAGE)));

        const offset = (currentPage - 1) * PER_PAGE;
        const pageFolders = folders.slice(offset, currentPage * PER_PAGE);

        /* Giữ lại data ảnh đã fetch, chỉ thêm item mới nếu chưa có */
        setDataList(prev => {
            const prevMap = Object.fromEntries(prev.map(item => [item.patch, item]));
            return pageFolders.map((folder, i) =>
                prevMap[folder.name] ?? {
                    stt:   folders.length - (offset + i),
                    id:    v4(),
                    img1:  '',
                    img2:  '',
                    name:  'CHF',
                    patch: folder.name,
                }
            );
        });

        await Promise.all(pageFolders.map(f => fetchImages(f.name)));
        await fetchNames();
        setLoading(false);
    };

    useEffect(() => {
        setLoading(true);
        setDataList([]);
        window.scrollTo(0, 0);

        load(page);
        const timer = setInterval(() => load(page), 30000);
        return () => clearInterval(timer);
    }, [page]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const onResize = () => setColCount(window.innerWidth >= 768 && window.innerWidth <= 990 ? 3 : 4);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    /* ── chỉ hiển thị item đã có ảnh ── */
    const visibleItems = dataList.filter(item => item.img1);

    const renderGrid = () => {
        if (loading) return (
            <div className="detail-loading">
                <div className="loading-spinner" />
                <p>Đang tải ảnh...</p>
            </div>
        );

        if (visibleItems.length === 0) return (
            <div className="detail-empty">Chưa có mẫu nào trên trang này.</div>
        );

        return sliceIntoChunks(visibleItems, colCount).map((row, i) => (
            <div className="d-flex row" key={i}>
                {row.map(ele => (
                    <div
                        key={ele.patch}
                        className="d-flex col-6 col-lg-3 col-md-4"
                        onClick={() => { setSelect(ele); setShowModal(true); }}
                    >
                        <div className="card-design">
                            <div className="card-img-wrap">
                                <img src={ele.img1} alt="sản phẩm" className="card-img-inner" />
                                <div className="card-hover-overlay"><span>Xem chi tiết</span></div>
                            </div>
                            <div className="card-footer-text">
                                <p className="card-code">{ele.name}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        ));
    };

    const Pagination = () => totalPages <= 1 ? null : (
        <div className="pagination-wrap">
            <button className="pg-nav" onClick={() => setPage(p => p - 1)} disabled={page === 1}>← Trước</button>
            <span className="pg-current">Trang {page}/{totalPages}</span>
            <button className="pg-nav" onClick={() => setPage(p => p + 1)} disabled={page === totalPages}>Sau →</button>
        </div>
    );

    return (
        <div className="container wrapItemDetail">
            <div className="page-header-detail">
                <h2 className="page-title-detail">Mẫu Thiết Kế</h2>
                <p className="page-sub-detail">Nhấn vào mẫu để xem chi tiết</p>
            </div>

            <Pagination />
            <div className="grid-wrapper">{renderGrid()}</div>
            <Pagination />

            <button
                type="button"
                className="btn-xem-them"
                onClick={() => window.open('https://drive.google.com/drive/folders/1u0YOmrAUhE0av1wSgGV8OSxRqsZCBT_t?usp=sharing', '_blank')}
            >Xem thêm mẫu</button>

            {showModal && select && (
                <div className="modal-overlay-detail" onClick={() => setShowModal(false)}>
                    <div className="modal-box-detail" onClick={e => e.stopPropagation()}>
                        <button className="modal-close-btn-detail" onClick={() => setShowModal(false)}>✕</button>
                        <p className="modal-name-detail">{select.name}</p>
                        <div className="modal-imgs-row">
                            {select.img1 && <img src={select.img1} alt="mặt trước" className="modal-img-detail" />}
                            {select.img2 && select.img2 !== select.img1 && <img src={select.img2} alt="mặt sau" className="modal-img-detail" />}
                        </div>
                    </div>
                </div>
            )}

            <button className="floating-btn">
                <a href="https://zalo.me/4354315060256721375" target="_blank" rel="noreferrer" style={{ margin: 0, padding: 0 }}>
                    <img src="/zalo_sharelogo.png" style={{ width: 65, height: 65 }} alt="zalo" />
                </a>
            </button>
        </div>
    );
}

export default Detail;
